import { useEffect } from 'react'

/**
 * Riflesso del vetro che segue il puntatore: un solo listener per tutto il sito scrive `--mx`/`--my`
 * (pixel dal bordo) sull'elemento `[data-glow]` più vicino sotto il cursore. Solo con mouse o trackpad.
 */
export function usePointerGlow(): void {
  useEffect(() => {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return
    let frame = 0
    let last: PointerEvent | null = null

    const paint = () => {
      frame = 0
      const target = last?.target instanceof Element ? last.target.closest<HTMLElement>('[data-glow]') : null
      if (!last || !target) return
      const rect = target.getBoundingClientRect()
      target.style.setProperty('--mx', `${Math.round(last.clientX - rect.left)}px`)
      target.style.setProperty('--my', `${Math.round(last.clientY - rect.top)}px`)
    }

    const onMove = (event: PointerEvent) => {
      last = event
      if (!frame) frame = requestAnimationFrame(paint)
    }

    document.addEventListener('pointermove', onMove, { passive: true })
    return () => {
      document.removeEventListener('pointermove', onMove)
      cancelAnimationFrame(frame)
    }
  }, [])
}
